// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealStatusEntity from './entities/appeal-status.json';
import appealStatusMenu from '../pages/appeal-status/menu.json';
import appealStatusFullForm from '../pages/appeal-status/forms/full.json';
import appealStatusContextForm from '../pages/appeal-status/forms/context.json';
import appealStatusMiniForm from '../pages/appeal-status/forms/mini.json';
import appealStatusLookupForm from '../pages/appeal-status/forms/lookup.json';
import appealStatusTableView from '../pages/appeal-status/views/table.json';
import appealStatusDashboardView from '../pages/appeal-status/views/dashboard.json';

/** Тип запису «Статус звернення» зі сторінками пакета: меню, форми та подання з pages/appeal-status/. */
export const appealStatusDefinition: IRecordTypeDefinition = {
  ...appealStatusEntity,
  views: assembleViewSet({
      table: appealStatusTableView,
      dashboard: appealStatusDashboardView,
  }),
  form: appealStatusFullForm,
  forms: { full: appealStatusFullForm, context: appealStatusContextForm, mini: appealStatusMiniForm, lookup: appealStatusLookupForm },
  menu: appealStatusMenu,
} as IRecordTypeDefinition;
